export default __webpack_public_path__ + "static/media/institute-18-min.88d4c292.webp";